import { AssetEmbedType } from 'library/ts/model/enums/content/AssetEmbedType';
import { MPXAvailableProfileType } from 'library/ts/model/enums/mpx/MPXAvailableProfileType';
import { MPXMediaType } from 'library/ts/model/enums/mpx/MPXMediaType';
import { MPXVideoProperty } from 'library/ts/model/enums/mpx/MPXVideoProperty';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class TagContentUtilities extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'TagContentUtilities'
        });
    }
    assetEmbedType = (params = this.params) => {
        let assetsSet = 0;
        [AssetEmbedType.PID, AssetEmbedType.CID, AssetEmbedType.ASSET_URL].forEach((assetType) => {
            if (!this.utils.Type.isEmpty(params?.CONTENT[assetType])) {
                assetsSet++;
            }
        });
        if (assetsSet > 1) {
            return undefined;
        }
        if (this.utils.Type.isString(params?.CONTENT?.pid) && !this.utils.Type.isEmpty(params?.CONTENT?.pid)) {
            return AssetEmbedType.PID;
        }
        if (this.utils.Type.isString(params?.CONTENT?.contentId) && !this.utils.Type.isEmpty(params?.CONTENT?.contentId)) {
            return AssetEmbedType.CID;
        }
        if (this.utils.Type.isString(params.CONTENT?.assetURL) && !this.utils.Type.isEmpty(params?.CONTENT?.assetURL)) {
            return AssetEmbedType.ASSET_URL;
        }
        return undefined;
    };
    isLive = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        if ((this.utils.Type.isString(params?.CONTENT?.assetURL)
            &&
                this.utils.Type.isEmpty(params?.CONTENT?.assetURL) === false
            &&
                params?.CONTENT?.isLive === true)
            ||
                (metadata?.mediaType === MPXMediaType.LIVE)
            ||
                (this.utils.Type.isArray(metadata?.videoProperties)
                    &&
                        metadata?.videoProperties.includes(MPXVideoProperty.DAI_LIVE_STREAM))) {
            return true;
        }
        return params?.CONTENT?.isLive;
    };
    hasDAIAssetKey = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        const assetKey = this.getDAIAssetKey(params, metadata);
        return (this.utils.Type.isString(assetKey) &&
            !this.utils.Type.isEmpty(assetKey));
    };
    getDAIAssetKey = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        const assetKey = metadata?.daistreamKey;
        if (this.utils.Type.isEmpty(assetKey))
            return undefined;
        return assetKey;
    };
    isLiveDAIStream = (metadata = this?.tag?.model?.apiMetadata) => {
        return (this.utils.Type.isArray(metadata?.videoProperties) &&
            metadata?.videoProperties.includes(MPXVideoProperty.DAI_LIVE_STREAM));
    };
    isPID = (tag = this.tag) => {
        const pid = tag.params?.CONTENT?.pid || tag.model.apiMetadata?.pid;
        return this.utils.Type.isString(pid) && !this.utils.Type.isEmpty(pid);
    };
    isAssetURL = (tag = this.tag) => {
        const assetURL = tag.params?.CONTENT?.assetURL;
        return (this.utils.Type.isString(assetURL) &&
            !this.utils.Type.isEmpty(assetURL));
    };
    isDAIAsset = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        let isDAI = false;
        switch (this.assetEmbedType(this.params)) {
            case AssetEmbedType.ASSET_URL:
                isDAI = this.daiAssetURL(params?.CONTENT?.assetURL);
                break;
            case AssetEmbedType.PID:
                isDAI = this.daiMetadata(metadata);
                break;
        }
        return isDAI;
    };
    isMediaTypeLiveVideo = (metadata = this?.tag?.model?.apiMetadata) => {
        return (this.utils.Type.isString(metadata.mediaType) &&
            metadata.mediaType.toLowerCase() === MPXMediaType.LIVE.toLowerCase());
    };
    daiAssetURL = (assetURL) => {
        return (!this.utils.Type.isEmpty(assetURL) &&
            this.utils.URL.parser(assetURL).host.indexOf('dai.google.com') > -1);
    };
    daiMetadata = (metadata) => {
        let isDAI = false;
        switch (this.utils.Type.isEmpty(metadata)) {
            case true:
                isDAI = false;
                break;
            case false:
                if (this.utils.Type.isObject(metadata) &&
                    this.utils.Type.isArray(metadata.videoProperties) &&
                    metadata.videoProperties.includes(MPXVideoProperty.DAI_LIVE_STREAM)) {
                    isDAI = true;
                }
                break;
        }
        return isDAI;
    };
    assetManifestExtension = (url = '') => {
        return this.utils.URL.getFileExtension(this.utils.URL.parser(url).pathname);
    };
    getPartnerID = (params = this.params) => {
        if (this.utils.Type.isNullOrUndefined(params?.CONTENT?.partner)) {
            this?.logger?.log('getPartnerID', 'returning params.CONTENT.partner:', params?.CONTENT?.partner);
            return params.CONTENT.partner;
        }
        else {
            this?.logger?.log('getPartnerID', 'params.CONTENT.partner is unset... returning fallback constant: cbs');
            return 'cbs';
        }
    };
    isDRM = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        switch (this.utils.Type.isEmpty(params?.CONTENT?.drm)) {
            case true:
                return false;
            case false:
                return true;
        }
        return false;
    };
    isLocalLiveAffiliate = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        if (this.isLive(params, metadata) && this.assetEmbedType(params) === AssetEmbedType.ASSET_URL) {
            return (this.utils.URL.parser(this.params.CONTENT.assetURL).host.indexOf('.syncbak.com') > -1);
        }
        return false;
    };
    isLinearAdTrackable = (params = this.params, metadata = this?.tag?.model?.apiMetadata) => {
        return !this.utils.Type.isEmpty(metadata?.videoProperties) && this.utils.Type.isArray(metadata?.videoProperties) && metadata.videoProperties.includes(MPXVideoProperty.LINEAR_AD_TRACKING_PLUGIN);
    };
    isKidsContent = (metadata = this?.tag?.model?.apiMetadata) => {
        const { KIDS, YOUNGER_KIDS } = MPXAvailableProfileType;
        const videoProperties = metadata?.videoProperties;
        const genre = metadata?.genre;
        const availableForProfileTypes = metadata?.availableForProfileTypes;
        const kids = availableForProfileTypes?.includes(KIDS);
        const youngerKids = availableForProfileTypes?.includes(YOUNGER_KIDS);
        const isKidsContent = videoProperties?.includes(MPXVideoProperty.KIDS);
        const kidsGenre = genre?.toLowerCase() === 'kids' ||
            genre?.toLowerCase() === 'kids and family';
        return isKidsContent || kidsGenre || kids || youngerKids;
    };
}
